export const initialState = {
  user: null,
  eventDate: "",
  todaysEvent:
    localStorage.getItem("todaysEvent") == "undefined" ||
    localStorage.getItem("todaysEvent") == null
      ? []
      : JSON.parse(localStorage.getItem("todaysEvent")),
  hole:
    localStorage.getItem("hole") == null
      ? 1
      : JSON.parse(localStorage.getItem("hole")),
  location:
    localStorage.getItem("location") == null
      ? []
      : JSON.parse(localStorage.getItem("location")),
  atCourse:
    localStorage.getItem("atCourse") == null
      ? ""
      : JSON.parse(localStorage.getItem("atCourse")),
  isMonitored:
    localStorage.getItem("isMonitored") == null
      ? false
      : JSON.parse(localStorage.getItem("isMonitored")),
  scores:
    localStorage.getItem("scores") == null
      ? []
      : JSON.parse(localStorage.getItem("scores")),
  overs:
    localStorage.getItem("overs") == null
      ? []
      : JSON.parse(localStorage.getItem("overs")),
  netovers:
    localStorage.getItem("netovers") == null
      ? []
      : JSON.parse(localStorage.getItem("netovers")),
  skins:
    localStorage.getItem("skins") == null
      ? []
      : JSON.parse(localStorage.getItem("skins")),
  dogmeat:
    localStorage.getItem("dogmeat") == null
      ? []
      : JSON.parse(localStorage.getItem("dogmeat")),
  teammatch:
    localStorage.getItem("teammatch") == null
      ? []
      : JSON.parse(localStorage.getItem("teammatch")),
  players:
    localStorage.getItem("players") == null
      ? []
      : JSON.parse(localStorage.getItem("players")),
  sums: [],
  lowfront: "",
  lowback: "",
  frontteam: "",
  backteam: "",
};

function reducer(state, action) {
  // console.log(action);
  switch (action.type) {
    case "SET_USER":
      return {
        ...state,
        user: action.user,
      };
    case "EVENTDATE":
      // console.log("Event date saved", action);
      return {
        ...state,
        eventDate: action.eventDate,
      };

    case "ADDEVENT":
      // console.log("Event saved", action);
      return {
        ...state,
        todaysEvent: action.event,
      };

    case "SAVELOCATION":
      // console.log("Loc saved", action);
      return {
        ...state,
        location: action.location,
      };

    case "ATCOURSE":
      // console.log("Loc saved", action);
      return {
        ...state,
        atCourse: action.atCourse,
      };

    case "MONITOR":
      console.log("Monitored", action);
      return {
        ...state,
        isMonitored: action.isMonitored,
      };

    case "ADDPLAYER":
      const newPlayer = action.player;
      newPlayer.id = newPlayer.idgolfer;
      newPlayer.isSubmitted = "false";
      return {
        ...state,
        players: [...state.players, newPlayer],
      };

    case "ADDPLAYER1":
      const addPlayer = action.player;
      console.log(addPlayer);
      return {
        ...state,
        players: [...state.players, addPlayer],
      };

    case "DELETEPLAYER":
      //removing
      //clone the players list
      let newPlayerList = [...state.players];
      //check if product in basket
      const index = state.players.findIndex((p) => p.id === action.id);
      if (index >= 0) {
        //if item exists in basket remove it
        newPlayerList.splice(index, 1);
      } else {
        console.warn(
          "Can't remove player (id: $(action:id)) as it is not in the players list."
        );
      }
      //return everything in store but copy newBasket to basket
      return {
        ...state,
        players: newPlayerList,
      };

    case "RESTOREPLAYERS":
      return {
        ...state,
        players: [...state.players, action.players],
      };

    case "ADDWAGERS":
      let newPlayers = [...state.players]; //save state prior to change
      // for player ID(-1 none, 0 already recorded)
      // console.log(action)
      const indexPlayer = state.players.findIndex((p) => p.id === action.id);
      newPlayers[indexPlayer].inGroupSkins = action.inGroupSkins;
      newPlayers[indexPlayer].skinWager = action.skinWager;
      newPlayers[indexPlayer].inLow9 = action.inLow9;
      newPlayers[indexPlayer].low9 = action.low9;
      newPlayers[indexPlayer].inLow18 = action.inLow18;
      newPlayers[indexPlayer].low18 = action.low18;
      newPlayers[indexPlayer].team = action.team;
      newPlayers[indexPlayer].inTeam9 = action.inTeam9;
      newPlayers[indexPlayer].inTeam18 = action.inTeam18;
      newPlayers[indexPlayer].isSubmitted = action.isSubmitted;
      newPlayers[indexPlayer].isLocked = true;

      // console.log ("Player",  newPlayers[indexPlayer])

      return {
        ...state,
        players: newPlayers,
      };

    case "WAGERSCHANGED":
      let changedPlayer = [...state.players]; //save state prior to change
      // for player ID(-1 none, 0 already recorded)
      // console.log("Player", action);
      const indexedPlayer = state.players.findIndex((p) => p.id === action.id);
      changedPlayer[indexedPlayer].isSubmitted = action.isSubmitted;
      return {
        ...state,
        players: changedPlayer,
      };

    case "NEXTHOLE":
      return {
        ...state,
        hole: action.num.hole + 1,
      };

    case "LASTHOLE":
      return {
        ...state,
        hole: action.num.hole - 1,
      };

    case "SAVESCORE":
      let newScores = [...state.scores]; //save state prior to change
      // check if score for hole for player already exists(-1 none, 0 already recorded)
      const scoreExists = state.scores.findIndex(
        (scoreItem) =>
          scoreItem.id === action.score.id &&
          scoreItem.hole === action.score.hole
      );

      if (scoreExists < 0) {
        // add new score
        return {
          ...state,
          scores: [...state.scores, action.score],
        };
      } else {
        // score exists so change it
        newScores[scoreExists].strokes = action.score.strokes;
        return {
          ...state,
          scores: newScores,
        };
      }
    case "SAVEOVER":
      let newOvers = [...state.overs]; //save state prior to change
      // check if score for hole for player already exists(-1 none, 0 already recorded)
      const overExists = state.overs.findIndex(
        (scoreItem) =>
          scoreItem.id === action.score.id &&
          scoreItem.hole === action.score.hole
      );

      if (overExists < 0) {
        // add new score
        return {
          ...state,
          overs: [...state.overs, action.score],
        };
      } else {
        // score exists so change it
        newOvers[overExists].strokes = action.score.strokes;
        //console.log("newOvers",newOvers)
        return {
          ...state,
          overs: newOvers,
        };
      }
    case "SAVENETOVER":
      let newNetOvers = [...state.netovers]; //save state prior to change
      // check if score for hole for player already exists(-1 none, 0 already recorded)
      const netoverExists = state.netovers.findIndex(
        (scoreItem) =>
          scoreItem.id === action.score.id &&
          scoreItem.hole === action.score.hole
      );

      if (netoverExists < 0) {
        // add new score
        return {
          ...state,
          netovers: [...state.netovers, action.score],
        };
      } else {
        // score exists so change it
        newNetOvers[netoverExists].strokes = action.score.strokes;
        return {
          ...state,
          netovers: newNetOvers,
        };
      }
    case "SAVESKIN":
      // console.log("initialdispatchedSkin", action.skin.Amount)
      let newSkin = [...state.skins]; //save state prior to change
      const skinExists = state.skins.findIndex(
        (skinItem) => skinItem.Hole === action.skin.Hole
      );
      if (skinExists < 0) {
        // add new skin
        return {
          ...state,
          skins: [...state.skins, action.skin],
        };
      } else {
        // score exists so change it
        newSkin[skinExists]["Winner"] = action.skin.Winner;
        // console.log("dispatchedSkin", action.skin.Amount)
        newSkin[skinExists]["Amount"] = action.skin.Amount;
        // console.log("newSkins", newSkin)
        return {
          ...state,
          skins: newSkin,
        };
      }
    case "SAVETEAMSCORE":
      let newTeam = [...state.teammatch]; //save state prior to change
      const teamExists = state.teammatch.findIndex(
        (s) => s.hole === action.teammatch.hole
      );
      // console.log("teamExists", teamExists)
      if (teamExists < 0) {
        // add new score
        return {
          ...state,
          teammatch: [...state.teammatch, action.teammatch],
        };
      } else {
        // score exists so change it
        newTeam[teamExists]["plusTotal"] = action.teammatch.plusTotal;
        newTeam[teamExists]["minusTotal"] = action.teammatch.minusTotal;
        newTeam[teamExists]["result"] = action.teammatch.result;
        return {
          ...state,
          teammatch: newTeam,
        };
      }

    case "SAVEDOGMEAT":
      let newDM = [...state.dogmeat]; //save state prior to change
      const dmExists = state.dogmeat.findIndex(
        (s) => s.hole === action.dogmeat.hole
      );
      // console.log("DM exists", dmExists);

      if (dmExists < 0) {
        return {
          ...state,
          dogmeat: [...state.dogmeat, action.dogmeat],
        };
      } else {
        // score exists so change it
        newDM[dmExists]["id"] = action.dogmeat.id;

        return {
          ...state,
          dogmeat: newDM,
        };
      }
    case "SAVESUMS":
      let newSum = [...state.sums]; //save state prior to change
      const sumsExists = state.sums.findIndex(
        (s) => s.id === action.sum.id && s.nine === action.sum.nine
      );
      //console.log("Sums exists", action.sum);
      if (sumsExists < 0) {
        return {
          ...state,
          sums: [...state.sums, action.sum],
        };
      } else {
        // sum exists so change it
        newSum[sumsExists]["total"] = action.sum.total;
        return {
          ...state,
          sums: newSum,
        };
      }

    case "SAVELOWFRONT":
      return {
        ...state,
        lowfront: [action.lowfront],
      };
    case "SAVELOWBACK":
      return {
        ...state,
        lowback: [action.lowback],
      };

    case "SAVEFRONTTEAM":
      // console.log(action);
      return {
        ...state,
        frontteam: [action.frontteam],
      };
    case "SAVEBACKTEAM":
      return {
        ...state,
        backteam: [action.backteam],
      };

    case "RESET":
      console.log("RESET");
      return {
        user: null,
        hole: 1,
        location: [],
        atCourse: [],
        players: [],
        scores: [],
        overs: [],
        netovers: [],
        skins: [],
        dogmeat: [],
        sums: [],
        teammatch: [],
        lowfront: "",
        lowback: "",
        frontteam: "",
        backteam: "",
      };

    default:
      return { state };
  }
}
export default reducer;
